/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_TradesInputs */



/**
* | output |
* | --- |
* | "Trades" |
*
* @param {Nav_TradesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_trades = /** @type {((inputs?: Nav_TradesInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_TradesInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tausch")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échanges")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("交换")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("交換")
	if (locale === "ko") return /** @type {LocalizedString} */ ("교환")
	return /** @type {LocalizedString} */ ("Trades")
});